/**
 * @generated SignedSource<<4d24152cebfe7599069129d0d596abe8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderApp_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Order_query">;
  readonly " $fragmentType": "OrderApp_query";
};
export type OrderApp_query$key = {
  readonly " $data"?: OrderApp_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderApp_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderApp_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Order_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "cab6713a457dfca564ecb2a70fd7f3a8";

export default node;
